/**
 * Demandbase Targeting Feature
 * @module
 */



var VENDOR = 'demandbase';

var pluginAudienceDemandbase: AudiencePluginConfig = {
  provider: require('core/plugins/providers/default_jsonp'),
  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceDemandbase);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceDemandbase;
}

